import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSubscriptionState } from "@/zustand/SubscriptionState";
import { useStartSubscriptionView } from "@/hooks/useStartSubscriptionView";
import { toast } from "@/hooks/useToast";
import { ToastAction } from "@/components/primitives/toast";

/**
 * Watches the planRestricted flag in SubscriptionState.
 * When a backend 403 Stripe.PlanFeatureRestricted is received,
 * shows a toast with an "Upgrade" action that opens the subscription view.
 * Mount this in ChatPage so it is always active for authenticated users.
 */
export function usePlanRestrictionToast() {
  const planRestricted = useSubscriptionState((s) => s.planRestricted);
  const setPlanRestricted = useSubscriptionState((s) => s.setPlanRestricted);
  const startSubscriptionView = useStartSubscriptionView();
  const { t } = useTranslation();

  useEffect(() => {
    if (!planRestricted) {
      return;
    }

    toast({
      description: t("subscription.planRestricted"),
      action: (
        <ToastAction
          altText={t("subscription.upgrade")}
          onClick={() => startSubscriptionView()}
        >
          {t("subscription.upgrade")}
        </ToastAction>
      ),
    });

    setPlanRestricted(false);
  }, [planRestricted, setPlanRestricted, startSubscriptionView, t]);
}
